import type { IComponentController } from '@wix/editor-elements-types/thunderbolt';

const mapActionsToProps: IComponentController = ({ updateProps }) => ({
  onChange: (nextValue: Array<string>) => {
    updateProps({ value: nextValue });
  },
});

export default mapActionsToProps;
